
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Faq",
      function () {
        return require("private-next-pages/Faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Faq"])
      });
    }
  